import {
  BarChartOutlined,
  CalendarOutlined,
  LayoutOutlined,
  OrderedListOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "../../hooks";
import { hasPermission } from "../../utils/helpers";
import SectionTabs from "../SectionTabs";

/* The same rail the sidebar's second column shows on desktop, in the same
 * order. It exists separately because that column is desktop-only — and a strip
 * of view tabs stacked under this strip of section tabs would be two rows of
 * tabs saying different things, which reads as a mistake. One rail. */
const DASHBOARD_SECTIONS = [
  { key: "/", label: "میزکار", icon: <LayoutOutlined /> },
  {
    key: "/stats",
    label: "وضعیت سازمان",
    icon: <BarChartOutlined />,
    permission: "manage_org",
  },
  /* Whichever task list this person has. Someone who manages tasks gets the
     organization-wide one, where their own tasks are a tab. */
  {
    key: "/all-tasks",
    label: "همه تسک‌ها",
    icon: <UnorderedListOutlined />,
    permission: "manage_tasks",
  },
  {
    key: "/my-tasks",
    label: "تسک‌های من",
    icon: <OrderedListOutlined />,
    withoutPermission: "manage_tasks",
  },
  { key: "/calendar", label: "تقویم من", icon: <CalendarOutlined /> },
];

const DashboardSectionTabs = () => {
  const isMobile = useMediaQuery("(max-width: 992px)");
  const navigate = useNavigate();
  const { pathname } = useLocation();

  if (!isMobile) return null;

  const items = DASHBOARD_SECTIONS.filter(
    (section) =>
      (!section.permission || hasPermission(section.permission)) &&
      (!section.withoutPermission || !hasPermission(section.withoutPermission)),
  );

  return (
    <SectionTabs
      items={items}
      activeKey={pathname}
      onChange={(key) => navigate(key)}
    />
  );
};

export default DashboardSectionTabs;
